import * as R from 'ramda';

import InputDateRange from '@atom/components/common/inputDateRange/InputDateRange';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';
import {
  convertRangeDateToMillis,
  DateRange,
  DateRangeTerminator,
} from '@atom/utilities/workOrdersDateFilterUtilities';

import classes from './attributeFilterGroup.module.css';

interface Props {
  value: {
    from?: number;
    to?: number;
    preset?: DateRange;
  };
  label: string;
  onChange: (value: any) => void;
}

const DateRangeFilter = ({ value, label, onChange }: Props) => {
  const getDateValue = (property: string) => {
    const dateValue = R.pathOr(null, [property], value);

    if (!isNilOrEmpty(dateValue)) {
      return new Date(Number(dateValue));
    }

    return null;
  };

  const handleDateChange =
    (property: string, terminator: DateRangeTerminator) => (val: Date) => {
      onChange({
        [property]: convertRangeDateToMillis(val, terminator, value?.preset),
      });
    };

  const handlePresetChange = (newValue: string) => {
    onChange({
      from: null,
      to: null,
      preset: newValue,
    });
  };

  const presetSelected = isNilOrEmpty(value?.preset)
    ? DateRange.ANYTIME
    : value?.preset;

  return (
    <div className={classes.dateRangeContainer}>
      <InputDateRange
        label={label}
        presetSelected={presetSelected}
        startDateValue={getDateValue('from')}
        handleStartChange={handleDateChange('from', DateRangeTerminator.START)}
        endDateValue={getDateValue('to')}
        handleEndChange={handleDateChange('to', DateRangeTerminator.END)}
        handleSelectDatePreset={selected => handlePresetChange(selected?.value)}
      />
    </div>
  );
};

export default DateRangeFilter;
